import { AddButton } from '@core/components/Buttons';
import { permissaoUtils } from '@core/util/permissaoUtil';
import {
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  FormControlLabel,
  List,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ConfiguracaoContext } from 'app/main/configuracao/ConfiguracaoContext';
import React, { Fragment, useContext, useMemo } from 'react';
import { VinculoAutomaticoBody, VinculoAutomaticoHeader } from '..';
import { CategoriaContext } from '../../CategoriaContext';
import { ContainerHead, ContainerList, ContainerTable } from '../../styles';
import CategoriaItem from '../CategoriaItem/CategoriaItem';

const titles = {
  receita: '1. Receitas',
  despesa: '2. Despesas',
  vinculo: 'Vínculos automáticos de categorias',
};
const buttonAdd = {
  receita: 'Adicionar receita',
  despesa: 'Adicionar despesa',
};

const CategoriaTable = ({ id, onRemove, onAdd, onEdit, onChangeVinculoAutomatico }) => {
  const [, setOpen] = useContext(CategoriaContext).dialogOpen;

  const [classesReceita] = useContext(CategoriaContext).classesReceita;
  const [classesDespesa] = useContext(CategoriaContext).classesDespesa;
  const [readOnly] = useContext(ConfiguracaoContext).categoriaReadOnly;

  /**
   * Dispara a ação de abir o modal
   * @param {string} type 'receita' ou 'despesa'
   */
  const handleOpenModal = (type) => {
    setOpen(type);
  };

  const handleAdd = (classe) => {
    onAdd(classe, classesReceita, classesDespesa);
  };

  const Head = ({ title, tipo }) => (
    <ContainerHead>
      <ExpansionPanelSummary style={{ paddingLeft: 16 }} expandIcon={<ExpandMoreIcon />}>
        <Typography style={{ width: 90, marginRight: 16, fontWeight: 700 }} variant="button">
          {title}
        </Typography>
        {/* De acordo com a Keila só é necessário ter a permissão de editar */}
        <FormControlLabel
          onClick={(event) => event.stopPropagation()}
          onFocus={(event) => event.stopPropagation()}
          control={
            permissaoUtils.categoria().editar && !readOnly ? (
              <AddButton onClick={() => handleOpenModal(tipo)}>{buttonAdd[tipo]}</AddButton>
            ) : (
              <></>
            )
          }
        />
      </ExpansionPanelSummary>
    </ContainerHead>
  );
  const Body = React.memo(
    ({ classes }) => (
      <ExpansionPanelDetails style={{ padding: 8 }}>
        <ContainerList>
          <List component="nav" style={{ paddingTop: 0 }}>
            {classes
              .filter((classe) => !!classe)
              .map((classe) => (
                <Fragment key={classe.id}>
                  <CategoriaItem
                    key={classe.id}
                    id={id}
                    classe={classe}
                    onAdd={handleAdd}
                    onEdit={onEdit}
                    onRemove={onRemove}
                  />
                  <Divider />
                </Fragment>
              ))}
          </List>
        </ContainerList>
      </ExpansionPanelDetails>
    ),
    (prev, next) => JSON.stringify(prev.classes) === JSON.stringify(next.classes)
  );

  return useMemo(
    () => (
      <ContainerTable>
        <ExpansionPanel defaultExpanded>
          <Head title={titles.receita} tipo="receita" />
          <Divider />
          <Body classes={classesReceita} tipo="Receita" />
        </ExpansionPanel>
        <ExpansionPanel defaultExpanded>
          <Head title={titles.despesa} tipo="despesa" />
          <Divider />
          <Body classes={classesDespesa} tipo="Despesa" />
        </ExpansionPanel>
        {classesReceita.length + classesDespesa.length > 0 && (
          <ExpansionPanel defaultExpanded>
            <VinculoAutomaticoHeader title={titles.vinculo} />
            <Divider />
            <VinculoAutomaticoBody onChangeVinculoAutomatico={onChangeVinculoAutomatico} />
          </ExpansionPanel>
        )}
      </ContainerTable>
    ),
    // Memoização intencional: as funções são recriadas a cada render e incluí-las anularia o memo;
    // o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [classesReceita, classesDespesa, readOnly]
  );
};

export default CategoriaTable;
